// Helper per il redirect post-login cross-origin (es. ritorno all'app Handover).
//
// Contesto: il login non è più sull'Account Portal hostato di Clerk ma sul componente
// <SignIn> embeddato in Crafter. La validazione del `redirect_url` passa quindi al
// ClerkProvider lato SPA. Servono due cose perché un redirect verso un'altra origine
// (l'app Handover) funzioni:
//   1) l'origine dev'essere whitelisted in `allowedRedirectOrigins`, altrimenti Clerk
//      la considera "unsafe" e usa il fallback (/app/bots);
//   2) la navigazione finale verso quell'origine NON può passare da vue-router (gestisce
//      solo rotte interne): va fatta con una hard navigation (window.location).

/**
 * Parsa una stringa comma-separated di origini permesse (stesso formato di
 * VITE_UMAMI_DOMAINS) in un array pulito, scartando vuoti e spazi.
 * @param {string|undefined|null} raw
 * @returns {string[]}
 */
export function parseAllowedRedirectOrigins(raw) {
  if (!raw || typeof raw !== 'string') return [];
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * True se `to` è un URL assoluto http(s) verso un'origine diversa da `currentOrigin`.
 * Gli URL relativi (rotte interne) e quelli same-origin tornano false → vue-router.
 * @param {string} to
 * @param {string} currentOrigin - tipicamente window.location.origin
 * @returns {boolean}
 */
export function isExternalUrl(to, currentOrigin) {
  if (typeof to !== 'string' || !/^https?:\/\//i.test(to)) return false;
  try {
    return new URL(to).origin !== currentOrigin;
  } catch {
    return false;
  }
}
